import React from "react";
import { Helmet } from "react-helmet";
import styled from "styled-components";
import HomeHero from "./Components/home/HomeHero";
import HomeStatement from "./Components/home/HomeStatement";
import HomeCapabilities from "./Components/home/HomeCapabilities";
import HomeTrust from "./Components/home/HomeTrust";
import HomeReleases from "./Components/home/HomeReleases";
import HomeRoster from "./Components/home/HomeRoster";
import HomeIndustry from "./Components/home/HomeIndustry";
import HomeCTA from "./Components/home/HomeCTA";
import PartnerSectionComponent from "./Components/Partners";

const Page = styled.div`
  overflow: clip;
`;

function Home() {
  return (
    <Page>
      <Helmet>
        <title>RMS — Regime Music Societe | Publishing &amp; Artist Services</title>
        <meta
          name="description"
          content="Regime Music Societe builds culture-led releases, publishing value, and global artist partnerships from Atlanta to the world."
        />
        <meta property="og:title" content="RMS — Regime Music Societe" />
        <meta
          property="og:description"
          content="Culture-led publishing, original compositions, catalog strategy, and global-facing artist services."
        />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://rmsociete.com/images/REGIME_logo.svg" />
        <meta property="og:url" content="https://rmsociete.com/" />
        <meta property="og:image" content="https://rmsociete.com/images/REGIME_logo.svg" />
        <link rel="canonical" href="https://rmsociete.com/" />
        <meta
          name="keywords"
          content="music publishing, artist services, catalog development, original compositions, RMS, Regime Music"
        />
      </Helmet>

      <HomeHero />
      <HomeStatement />
      <HomeCapabilities />
      <HomeTrust />
      <HomeReleases />
      <HomeRoster />
      <HomeIndustry />
      <HomeCTA />
      <PartnerSectionComponent />
    </Page>
  );
}

export default Home;
